"use client";
import React from "react";
export function PricingTable() {
  async function checkout() {
    const res = await fetch("/api/stripe/checkout", { method: "POST" });
    const { url } = await res.json();
    window.location.href = url;
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      {["Basic","Pro"].map((name)=>(
        <div key={name} className="rounded-2xl border p-6">
          <h3 className="text-xl font-semibold">{name}</h3>
          <p className="mt-2">Great for getting started.</p>
          <button onClick={checkout} className="mt-4 rounded-xl bg-black px-4 py-2 text-white min-h-[44px]">Choose {name}</button>
        </div>
      ))}
    </div>
  );
}
export default PricingTable;
